import { getRootUrl } from '@shared-config/rootUrl';
import dayjs from 'dayjs';
import type { OrgAnalytics } from 'src/types';
import { baseFetch, formatPrice } from 'src/utils';

export const getAnalyticsAPI = async (params: {
  startDate: string;
  endDate: string;
  requesters: string[] | 'all';
  vendors: string[] | 'all';
}) => {
  const { startDate, endDate, requesters, vendors } = params;

  const queryParams = new URLSearchParams({
    startDate,
    endDate,
    requesters: requesters === 'all' ? 'all' : JSON.stringify(requesters),
    vendors: vendors === 'all' ? 'all' : JSON.stringify(vendors),
  });

  const res = await baseFetch(`/api/org/analytics?${queryParams.toString()}`, {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch analytics');
  }

  const data = await res.json();

  const analytics = data.analytics as OrgAnalytics[];

  if (!analytics || analytics.length === 0) {
    return null;
  }

  // #########################################################################################
  // instead of reduce here, we need to loop over and update each item to also have
  // a formatted price by default, formatted date string by default,
  // and a premade get page link to the cart
  // #########################################################################################
  let totalItems = 0;
  let totalPrice = 0;

  const formattedAnalytics = analytics.map((analytic) => {
    let skipPrice = false;
    if (analytic.cart.cartCCY !== 'USD' || analytic.cart.cartCCYS !== '$') {
      skipPrice = true;
    }

    const cartTotalPrice =
      typeof analytic.cart.cartTotalPrice === 'number'
        ? analytic.cart.cartTotalPrice
        : parseFloat(analytic.cart.cartTotalPrice);

    totalItems += analytic.cart.cartTotalQty || 0;
    totalPrice += skipPrice ? 0 : cartTotalPrice || 0;

    const formattedCartPrice = formatPrice(
      cartTotalPrice,
      analytic.cart.locale || 'us',
      analytic.cart.cartCCY,
      analytic.cart.cartCCYS,
      false,
    );

    return {
      ...analytic,
      cartApproved: analytic.status === 'approved' ? 'Yes' : 'No',
      formattedCartPrice: formattedCartPrice,
      formattedDate: dayjs(analytic.requestedAt).format('MM/DD/YYYY'),
      linkToCart: `${getRootUrl()}/get/${analytic.cart.id}`,
    };
  });

  const totalCarts = analytics.length;
  const formattedTotalPrice = formatPrice(totalPrice, 'us', 'USD', '$', false);

  return {
    analytics: formattedAnalytics,
    totalCarts,
    totalItems,
    totalPrice: formattedTotalPrice,
  };
};
